<template>
  <b-modal
    :visible="value"
    centered
    no-close-on-backdrop
    @change="$emit('input', $event)"
  >
    <template v-slot:modal-title>
      <i class="fas fa-exclamation-circle text-danger mr-2"></i>ลบรายการ
    </template>
    <p>
      <template v-if="sentToErp">
        ใบขอซื้อนี้ถูกส่งเข้าระบบ ERP แล้ว การลบจะแจ้งให้ ERP ลบใบขอซื้อนี้ด้วย และไม่สามารถย้อนกลับได้<br />
      </template>
      คุณต้องการลบใบขอซื้อนี้ใช่หรือไม่
    </p>
    <template v-slot:modal-footer>
      <b-button
        class="cancel-btn"
        variant="outline-secondary"
        @click="$emit('input', false)"
        >ย้อนกลับ</b-button
      >
      <b-button
        class="confirm-btn"
        variant="danger"
        @click="$emit('confirm')"
        >ลบรายการ</b-button
      >
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "PrDeleteConfirmModal",
  props: {
    value: { type: Boolean, default: false },
    sentToErp: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.cancel-btn {
  padding: 8px 30px;
  font-size: 14px;
  font-weight: 600;
  border-color: #acb5bd;
  color: #212529;
}
.cancel-btn:hover {
  background-color: #acb5bd;
  color: #fff;
}

.confirm-btn {
  padding: 8px 50px;
  font-size: 14px;
  font-weight: 600;
}
</style>
